module.exports = __webpack_public_path__ + "img/avatar.d961d73a.png";